__turbopack_context__.v({
  "tabActions": "Tabs-module__oOxP3q__tabActions",
  "tabs": "Tabs-module__oOxP3q__tabs",
  "tabsHeader": "Tabs-module__oOxP3q__tabsHeader",
  "tabsHeaderContainer": "Tabs-module__oOxP3q__tabsHeaderContainer",
  "tabsHeaderContainerNoPadding": "Tabs-module__oOxP3q__tabsHeaderContainerNoPadding",
  "tabsHeaderContainerSticky": "Tabs-module__oOxP3q__tabsHeaderContainerSticky",
  "tabsHeaderItem": "Tabs-module__oOxP3q__tabsHeaderItem",
  "tabsHeaderItemActive": "Tabs-module__oOxP3q__tabsHeaderItemActive",
  "tabsHeaderSticky": "Tabs-module__oOxP3q__tabsHeaderSticky",
});
